import { addLabel, editLabel } from './request';
export default {
  data() {
    return {
      dialogVisible: false,
      dataFrom: {
        name: '',
        classificationId: this.$route.params.id
      }
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('名称'),
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    init(data) {
      console.log(data);
      if (data.classificationId) {
        this.dataFrom.classificationId = data.classificationId;
      }
      if (data.labelId) {
        this.dataFrom = {
          name: data.name,
          labelId: data.labelId
        };
      }
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let fun = this.dataFrom.labelId ? editLabel : addLabel;
          fun(this.dataFrom).then(res => {
            this.$message.success(this.$t('操作成功'));
            this.$emit(this.$t('ok'), res);
            this.$emit(this.$t('cancel'));
          });
        }
      });
    }
  }
};